var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"image",attrs:{"src":_vm.src,"fit":_vm.fit}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }